/**
 * Which order the inbox opens in (Context+, 2026-10-21).
 *
 * Priority order is the default for anyone the backend scores rows for
 * (the Context+ capability — Matthew and the memo engine first; the
 * design brief leaves paralegal inboxes as an open question, so they
 * keep arrival order). A viewer who switches is remembered in the
 * browser, like the list width and the rail's collapsed state.
 */

export const INBOX_SORT_RECEIVED = "received";
export const INBOX_SORT_PRIORITY = "priority";
export const INBOX_TRIAGE_CAPABILITY = "ai.inbox_briefing";

const STORAGE_KEY = "inboxSort";

const readStored = () => {
  try {
    const raw = globalThis.localStorage?.getItem(STORAGE_KEY);
    return raw === INBOX_SORT_PRIORITY || raw === INBOX_SORT_RECEIVED
      ? raw
      : null;
  } catch {
    return null;
  }
};

export const rememberInboxSort = (sort) => {
  try {
    if (sort === INBOX_SORT_PRIORITY || sort === INBOX_SORT_RECEIVED) {
      globalThis.localStorage?.setItem(STORAGE_KEY, sort);
    }
  } catch {
    // Preference just won't persist this session.
  }
};

/**
 * The order to open with: the remembered choice when there is one,
 * otherwise priority for a viewer with the capability and arrival
 * order for everyone else. Never priority without the capability —
 * the rows would carry no badge to explain the order.
 */
export const initialInboxSort = (hasCapability) => {
  const allowed =
    typeof hasCapability === "function" && hasCapability(INBOX_TRIAGE_CAPABILITY);
  if (!allowed) return INBOX_SORT_RECEIVED;
  return readStored() || INBOX_SORT_PRIORITY;
};
